/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <!-- <group-list v-if="isGroup && !storeId"/> -->
    <store-list/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupList from './GroupList.vue'
  import StoreList from './StoreList.vue'
  export default {
    name: 'RoomCalendar',
    components: { GroupList, StoreList },
    computed: {
      ...mapGetters(['isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
